import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import "@fontsource/poppins";

const navItems = [
  { label: "Home", targetId: null, path: "/" },
  { label: "Our Services", targetId: "our-solutions", path: null },
  {
    label: "Hereditary Cancer Clinic",
    targetId: null,
    path: "/hereditary-cancer-clinic",
  },
  { label: "About Us", targetId: null, path: "/about-us" },
  { label: "Contact Us", targetId: "contact-us", path: null },
];

export const NavBar: React.FC = () => {
  const navigate = useNavigate();

  const handleNavClick = (targetId?: string, path?: string) => {
    if (path) {
      navigate(path, { state: { scrollToId: targetId, ts: Date.now() } });
    } else if (targetId) {
      if (window.location.pathname === "/") {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        navigate("/", { state: { scrollToId: targetId, ts: Date.now() } });
      }
    }
  };

  const handleLogoClick = () => {
    window.location.assign("https://hereditarycancer.ai/");
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "#1B2E85",
        zIndex: 50,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Toolbar
          sx={{
            minHeight: "80px !important",
            height: "80px",
            px: { xs: 3, lg: 5 },
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Left: Logo */}
          <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
            <Box
              onClick={handleLogoClick}
              sx={{
                fontSize: { xs: "1.25rem", lg: "1.875rem" },
                fontWeight: "bold",
                lineHeight: 1,
                cursor: "pointer",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: "white",
                  fontSize: "inherit",
                  fontWeight: "inherit",
                }}
              >
                HereditaryCancer
              </Typography>
              <Typography
                component="span"
                sx={{
                  color: "#8FCFF4",
                  fontSize: "inherit",
                  fontWeight: "inherit",
                }}
              >
                .ai
              </Typography>
            </Box>
          </Box>

          {/* Center: Nav links */}
          <Box
            sx={{
              display: { xs: "none", lg: "flex" },
              alignItems: "center",
              justifyContent: "center",
              gap: { lg: 1.5, xl: 2 },
              flex: 1,
              mx: "auto",
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item.label}
                onClick={() =>
                  handleNavClick(
                    item.targetId || undefined,
                    item.path || undefined
                  )
                }
                sx={{
                  color: "white",
                  fontSize: { lg: "1rem", xl: "1.125rem" },
                  fontWeight: "normal",
                  px: 0.75,
                  py: 0.5,
                  borderRadius: 1,
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  fontFamily: "Arial, sans-serif",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  },
                  transition: "background-color 0.2s ease-in-out",
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          {/* Right: Spacer for layout balance */}
          <Box sx={{ flex: 1 }} />
        </Toolbar>

        {/* Bottom border */}
        <Box
          sx={{
            width: "100%",
            height: "1px",
            backgroundColor: "#1B2E85",
          }}
        />
      </Box>
    </AppBar>
  );
};
